import React from 'react';
import ArrowLeftLight from 'src/assets/images/ArrowLeftLight.svg';
import ArrowRightLight from 'src/assets/images/ArrowRightLight.svg';
import {
    TimelineHeader,
    Navigation,
    TimelineHeaderDatePicker,
    TimelineHeaderCaseCount,
    NavArrow,
    DateRangeIndicator,
    TextDemi,
} from './TimelineNavigation.styled';
import { useSelector } from 'react-redux';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { isToday } from 'src/utils/dateUtils';
import { dynamicPluralization, logErrorToConsole } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
  
const TimelineNavigation = (props) => {
    const dateRange = useSelector(
        (state) => state.filterReducer.visibleDateRange
    );
    const selectedDate = useSelector(
        (state) => state.filterReducer.selectedDate
    );

    const nextWeek = () => {
        const newMinDate = new Date(selectedDate);
        newMinDate.setDate(newMinDate.getDate() + 7);
        props.selectedDateDispatcher(newMinDate);
    };
    const { t } = useTranslation();
    const prevWeek = () => {
        const newMinDate = new Date(selectedDate);
        newMinDate.setDate(newMinDate.getDate() - 7);
        props.selectedDateDispatcher(newMinDate);
    };
    return (
        <Navigation>
            <TimelineHeader>
                {(() => {
                    let fromDate = new Intl.DateTimeFormat('en', {
                        day: '2-digit',
                    }).format(dateRange[0]);
                    let fromMonth = new Intl.DateTimeFormat('en', {
                        month: 'short',
                    }).format(dateRange[0]);
                    let toDate = new Intl.DateTimeFormat('en', {
                        day: '2-digit',
                    }).format(dateRange[1]);
                    let toMonth = new Intl.DateTimeFormat('en', {
                        month: 'short',
                    }).format(dateRange[1]);
                    let toYear = new Intl.DateTimeFormat('en', {
                        year: 'numeric',
                    }).format(dateRange[1]);

                    const weekDateString = `${fromDate} ${fromMonth} - ${toDate} ${toMonth} ${toYear}`;
                    return (
                        <>
                            <TimelineHeaderDatePicker>
                                <NavArrow onClick={prevWeek}>
                                    <img
                                        src={ArrowLeftLight}
                                        width="auto"
                                        height="auto"
                                    ></img>
                                </NavArrow>
                                <DateRangeIndicator>
                                    {weekDateString}
                                </DateRangeIndicator>
                                <NavArrow onClick={nextWeek}>
                                    <img
                                        src={ArrowRightLight}
                                        width="auto"
                                        height="auto"
                                    ></img>
                                </NavArrow>
                            </TimelineHeaderDatePicker>
                        </>
                    );
                })()}
                {!isToday(selectedDate) && (
                    <Button
                        id={'common-todayButton'}
                        show={true}
                        clicked={() => {
                            try {
                                props.selectedDateDispatcher(new Date());
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        width="58px"
                        height="28px"
                        margin="0 0 0 40px"
                        //warning
                        variant={ButtonStyles?.warning}
                    >
                        <TextDemi fontSize={'13px'}>{t('orders.todayLabel')}</TextDemi>
                    </Button>
                )}
            </TimelineHeader>

            <TimelineHeaderCaseCount>
                {props.caseCount}
                {'  '}
                {dynamicPluralization(t('orders.caseLabel'), t('orders.casesLabel'), props.caseCount)}
            </TimelineHeaderCaseCount>
        </Navigation>
    );
};

export default TimelineNavigation;
